import React from 'react';
import PropTypes from 'prop-types';

import ReactImageFallback from 'react-image-fallback';

import noImage from './no_image.png';
import loadingImage from './loading.gif';

function FileImage(props) {
    var src = props.src,
        alt = props.alt,
        style = props.style,
        onClick = props.onClick;


    return React.createElement(ReactImageFallback, {
        onClick: onClick,
        src: src,
        fallbackImage: noImage,
        initialImage: loadingImage,
        alt: alt,
        style: style
    });
}

FileImage.defaultProps = {
    src: '',
    alt: '',
    style: {}
};

FileImage.propTypes = process.env.NODE_ENV !== "production" ? {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func
} : {};

export default FileImage;